
  import {defineComponent} from 'vue';
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters} from "vuex";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'payment-fail-view',
    components: {
      HeaderComponent,
    },
    data() {
      return {
        expirationTime: 0,
        remainingTime: 0,
      }
    },
    computed: {
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    mounted(): void {
      this.expirationTime = new Date().getTime() + (5 * 1000);
      this.remainingTime = Math.round((this.expirationTime - new Date().getTime()) / 1000);

      const timer = setInterval(() => {
        this.remainingTime = Math.round((this.expirationTime - new Date().getTime()) / 1000);
        if (this.remainingTime <= 0) {
          clearInterval(timer);
          if (this.$route.name == 'PaymentFailView') {
            this.$router.replace(new NamedRouting('ProductListView'));
          }
        }
      }, 1000);
    }
  });
